<script lang="js">
    export let imageUrl = '/ShalomLogo.jpg';
    export let title = 'Corporales';
    export let description = 'Reductivos, Depilación, Estrías, Eliminación Tatuajes';
    export let buttonLabel = 'Ver Tratamiento';
    export let link = '/treatments/corporales';
    export let displayImage = false;
</script>

<div class="card-container">

  {#if displayImage}
    <a href={link} class="">
        <!-- <div class="card-image-wrapper">
        <img 
            src={imageUrl || "/ShalomLogo.jpg"} 
            alt="" 
            class="card-image"
        />
        </div> -->
      <div class="card-image-wrapper">
        <img 
            src={imageUrl || "/ShalomLogo.jpg"} 
            alt="" 
            class="card-image"
        />
      </div>
    </a>
  {/if}

  <!-- {#if !displayImage}
    <div class="card-image-wrapper">
        <img 
            src={imageUrl || "/ShalomLogo.jpg"} 
            alt="" 
            class="card-image"
        />
    </div>
  {/if} -->

  
  <div class="card-content">
    <a href={link} class="hover:no-underline">
      <h2 class="card-title">{title}</h2>
      <p class="card-description">{description}</p>
    </a>
    <a class="card-button hover:no-underline" href={link}>
      {buttonLabel}
    </a>
  </div>
</div>


<!-- <div class="overflow-hidden rounded-lg shadow-lg bg-white">
  <div class="relative">
    <img 
      src={imageUrl || "/placeholder.svg"} 
      alt="" 
      class="w-full h-80 object-cover"
    />
  </div>
  <div class="p-6 bg-white">
    <h2 class="text-3xl font-bold text-gray-900 mb-2">{title}</h2>
    <p class="text-gray-700 mb-6">{description}</p>
    <button class="text-emerald-500 font-medium hover:text-emerald-600 transition-colors">
      {buttonLabel}
    </button>
  </div>
</div> -->


<style lang="scss">    
  
.card-container {

    $mobile: 480px;

    //max-width: 28rem; // 448px (Tailwind's max-w-md)
    overflow: hidden;
    border-radius: 5px; // 0.5rem; // 8px (rounded-lg)
    box-shadow: 0 10px 15px -3px rgba(0,0,0,0.1), 0 4px 6px -2px rgba(0,0,0,0.05); // shadow-lg
    background: #fff;

    .card-image-wrapper {
        position: relative;
    }

    .card-image {
        width: 100%;
        height: 20rem; // 320px (h-80)
        object-fit: cover;
        display: block;

        //@media (max-width: var(--screen-mobile)) {
        // Mobile (up to $mobile)
        @media (max-width: $mobile) {
            max-height: 200px;
        }
    }

    .card-content {
        padding: 1.5rem; // 24px (p-6)
        background: #fff;
    }

    .card-title {
        font-size: 1.875rem;
        font-weight: 700;
        color: #1a202c; 
        margin-bottom: 0.5rem;
        line-height: 35px;
    }

    .card-description {
        color: #4a5568; // #4a5568 is Tailwind's gray-700
        margin-bottom: 1.5rem; // 24px (mb-6)
    }

    .card-button {
        color: white;
        background-color: var(--theme-card-cta-background-color) !important;
        border-radius: 5px;
        //color: white;
        padding: 5px 10px;

        font-weight: 500; // medium
        background: none;
        border: none;
        cursor: pointer;
        transition: color 0.2s;

    &:hover {
        color: white; // Tailwind's emerald-600
    }
}

}
</style>

